export const timezones = Intl.supportedValuesOf('timeZone')
